<template>
  <div class="home">
    <!-- 顶部轮播图 -->
    <Carousel
      class="carousel_box"
      v-model="itemIndex"
      :autoplay="true"
      :autoplay-speed="5 * 1000"
      dots="inside"
      :loop="true"
      trigger="hover"
      arrow="never"
    >
      <CarouselItem v-for="(item, index) in carouselList" :key="index">
        <!-- @click="jumpToName('carouselDetail', { id: item.id }, item)" -->
        <div class="each_item is_link">
          <img :src="item.imgUrl" alt="" />
        </div>
      </CarouselItem>
    </Carousel>

    <!-- <section class="main_box"> -->
    <!-- 公告部分 -->
    <div class="bg_181A23">
      <div class="notice_box content_auto">
        <div class="notice_content">
          <div class="horn_box">
            <img
              class="full_img"
              src="./../../assets/images/gonggao-laba.png"
              alt=""
            />
          </div>
          <div class="notice">
            <div class="swiper-container" style="height:46px;">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in hotNoticeListArr"
                  :key="index"
                  class="swiper-slide"
                >
                  <span @click="jumpToPath('/noticeDetail', { id: item.id })">
                    {{ `${item.title}(${item.createTime})` }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 五个热门币种部分 -->
    <div class="bg_181A23">
      <div
        v-loading="recommendLoading || noQuotes"
        element-loading-background="rgba(0, 10, 34, 1)"
        class="hot_coin_box content_auto"
      >
        <div
          class="each_coin"
          v-for="item in recommendDataList"
          :key="item.marketId"
          @click="jumpToName('transaction', item)"
        >
          <div class="left_contet">
            <p class="coin_name">
              {{ item.market | initFilter('--') | marketFilter }}
            </p>
            <p>{{ item.price | initFilter('--') }}</p>
            <p class="cny_price">≈{{ item.cny | initFilter('--') }} CNY</p>
          </div>
          <div class="right_contet">
            <p
              :class="{
                up_green: Number(item.ratio) > 0,
                down_red: Number(item.ratio) < 0
              }"
              class="up_down"
            >
              {{ Number(item.ratio) > 0 ? '+' : ''
              }}{{ item.ratio | initFilter('--') }}%
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="h_20"></div>

    <!-- 行情部分 -->
    <div class="bg_181A23">
      <div class="market_box content_auto">
        <div class="market-title">{{ $t('主板区') }}</div>
        <div class="main-coin-key-box">
          <div
            v-for="item in tabList"
            :key="item.value"
            class="key-item"
            :class="{ active: currentTab === item.value }"
            @click="currentTab = item.value"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- 
        v-for="(value, key, index) in _dataList"
          :key="index"
          v-show="mainCoinCurrentKey === key" -->
        <MainCoin
          :coinList="mainboardDataList"
          :loading="loading || noQuotes"
        ></MainCoin>
      </div>
      <!-- 查看更多详情 -->
      <!-- <div class="look_more content_auto">
        <p class="is_link" @click="jumpToPath('/market')">
          <span>{{ $t('查看更多详情') }}</span>
          <img src="./../../assets/images/jinru.png" alt="" />
        </p>
      </div> -->
    </div>
    <!-- 介绍部分 -->
    <div class="introduce_box">
      <h1>{{ $t('值得信赖的一站式数字资产服务平台') }}</h1>
      <div class="introduce_content content_auto">
        <PlatformIntroduction
          v-for="(item, index) of introduceList"
          :key="index"
          :title="item.title"
          :content="item.content"
          :introductionImage="item.introduceImage"
        >
        </PlatformIntroduction>
      </div>
    </div>
    <!-- 二维码部分 -->
    <div class="qrcode_wrapper bg_181A23">
      <div class="qrcode_content content_auto">
        <div class="computed_box">
          <img
            class="full_img"
            src="./../../assets/images/computer.png"
            alt=""
          />
        </div>
        <div class="qrcode_description">
          <p>{{ $t('交易，随时随地') }}</p>
          <p class="description">
            {{ $t('多终端完美兼容，随时满足各种场景的交易需求。') }}
          </p>
          <div class="download">
            <template v-if="appDownloadQrCode">
              <p>{{ $t('扫码下载') }}</p>
              <div class="qrcode_img">
                <div v-if="appDownloadQrCode.ios" class="qrcode_img_item">
                  <img class="full_img" :src="appDownloadQrCode.ios" />
                  <div>
                    <img src="./../../assets/images/ios.png" />
                    <span>{{ $t('IOS下载') }}</span>
                  </div>
                </div>
                <div v-if="appDownloadQrCode.android" class="qrcode_img_item">
                  <img class="full_img" :src="appDownloadQrCode.android" />
                  <div>
                    <img src="./../../assets/images/android.png" />
                    <span>{{ $t('安卓下载') }}</span>
                  </div>
                </div>

                <!-- <canvas ref="QRCode_download"></canvas> -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- </section> -->
  </div>
</template>
<script>
import MainCoin from './components/MainCoin'
import PlatformIntroduction from './components/PlatformIntroduction'
import { advertiseList, fetchAPPDownloadLinks } from '@/api/slideshow'
import { hotNoticeList } from '@/api/notice'
import { fetchAllQuote, fetchRecommendTradingPair } from '@/api/market'
import { mapState } from 'vuex'
import QrCode from 'qrcode'
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper/dist/js/swiper.min.js'

export default {
  name: 'Home',
  components: {
    MainCoin,
    PlatformIntroduction
  },
  data() {
    return {
      appDownloadQrCode: null,
      recommendLoading: true,
      loading: true,
      itemIndex: 0,
      carouselList: [], // 保存轮播图列表
      hotNoticeListArr: [], // 热门公告标题列表
      // defaultCarouselImage: require('./../../assets/images/initImage.png'), // 默认轮播图图片
      introduceList: [
        {
          title: this.$t('金融级安全'),
          content: this.$t(
            '全方位金融风控系统和防盗系统，冷热钱包、多签系统保证资金安全'
          ),
          introduceImage: require('./../../assets/images/anquan.png')
        },
        {
          title: this.$t('快速充币'),
          content: this.$t('充值提现最快3分钟完成，保护客户不错过最佳投资机会'),
          introduceImage: require('./../../assets/images/chongbi.png')
        },
        {
          title: this.$t('全球服务'),
          content: this.$t(
            '全球业务服务网络覆盖，助您投资全球加密资产，与全球用户交易'
          ),
          introduceImage: require('./../../assets/images/fuwu.png')
        }
      ],
      hotCoinArray: [{}, {}, {}, {}, {}],
      currentTab: 'hot',
      hotIds: [],
      recommendIds: [],
      tabList: [
        { name: this.$t('热门'), value: 'hot' },
        { name: this.$t('涨幅榜'), value: 'increase' },
        { name: this.$t('跌幅榜'), value: 'decrease' }
      ]
    }
  },
  computed: {
    ...mapState({
      quotes: (store) => store.transaction.quotes
    }),
    mainboardDataList() {
      const _dataList = [...Object.values(this.quotes)]
      if (this.currentTab === 'hot') {
        return _dataList.filter((item) => this.hotIds.includes(item.marketId))
      }
      _dataList.sort((a, b) => b.ratio - a.ratio)
      if (this.currentTab === 'increase') {
        return _dataList.filter((item) => item.ratio > 0)
      }
      if (this.currentTab === 'decrease') {
        return _dataList.filter((item) => item.ratio < 0)
      }
      return []
    },
    recommendDataList() {
      const _dataList = [...Object.values(this.quotes)]
      return _dataList.filter((item) =>
        this.recommendIds.includes(item.marketId)
      )
    },
    noQuotes() {
      return !Object.keys(this.quotes).length
    }
  },
  created() {
    this.getAdvertiseAndNotice()
    this.getAllQuote()
    this.getRecommendTradingPair()
    this.generateAPPDownloadQrCode()
  },
  methods: {
    async generateAPPDownloadQrCode() {
      const data = await fetchAPPDownloadLinks()
      if (data) {
        const { android, ios } = data
        let linksReult
        if (android?.downloadAddress) {
          const url = await QrCode.toDataURL(android.downloadAddress, {
            width: 139,
            margin: 1,
            scale: 3
          })
          linksReult = { android: url }
        }
        if (ios?.downloadAddress) {
          const url = await QrCode.toDataURL(ios.downloadAddress, {
            width: 139,
            margin: 1,
            scale: 3
          })
          linksReult = Object.assign(linksReult || {}, {
            ios: url
          })
        }
        if (linksReult) this.appDownloadQrCode = linksReult
      }
    },
    async getRecommendTradingPair() {
      const data = await fetchRecommendTradingPair()
      this.recommendIds = data.map((item) => item.tradeId)
      this.recommendLoading = false
    },
    async getAllQuote() {
      const { quote } = await fetchAllQuote()
      this.hotIds = quote.reduce((calc, item) => {
        const { quoteV2 } = item
        calc.push(
          ...quoteV2.filter((item) => item.isHot).map((item) => item.marketId)
        )
        return calc
      }, [])
      // this.mainCoinKeyArray = sort.map((item) => item.toUpperCase())
      // this.mainCoinList = quote.reduce((calc, { area, quoteV2 }) => {
      //   calc[area.toUpperCase()] = quoteV2
      //   return calc
      // }, {})
      // this.hotCoinArray = this.mainCoinList.USDT.filter((item) => item.isHot)
      this.loading = false
    },
    jumpToPath(p, q) {
      this.$router.push({ path: p, query: q })
    },
    // params,
    jumpToName(name, item) {
      this.$store.commit('transaction/SET_TRADING_PAIR_DATA', item)
      this.$router.push({ name: name })
      // if (params.tradingPair) {
      //   params.tradingPair = params.tradingPair.replace(/\//, '_')
      // }
      // if (name === 'carouselDetail') {
      //   const { href } = this.$router.resolve({ name: name, params: params })
      //   switch (item.type) {
      //     case 1:
      //       window.open(href, '_blank')
      //       break
      //     case 2:
      //       window.open(item.linkUrl)
      //       break
      //     case 3:
      //       // 无操作
      //       break
      //   }
      // } else {
      //   this.$router.push({ name: name, params: params })
      // }
    },
    // 获取轮播图、热门公告
    async getAdvertiseAndNotice() {
      const [{ item }, hotNoticeListArr] = await Promise.all([
        await advertiseList({ location: 1 }),
        await hotNoticeList()
      ])
      this.carouselList = item
      this.hotNoticeListArr = hotNoticeListArr

      this.$nextTick(() => {
        // eslint-disable-next-line
        new Swiper('.swiper-container', {
          direction: 'vertical',
          loop: true,
          autoplay: true
          // 你的swiper配置选项
        })
      })
    },
    handleMainCoinKey(key) {
      this.mainCoinCurrentKey = key
    }
  },
  filters: {
    titleFilter(title, time) {
      let titleResult = ''
      let timeResult = time.slice(5, 10)
      if (title.length > 15) {
        titleResult = title.substr(0, 15) + '...'
      } else {
        titleResult = title
      }
      return titleResult + '(' + timeResult + ')'
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  min-width: 1200px;
  position: relative;
  background-color: #000;

  // 顶部轮播图
  .carousel_box {
    height: 400px;
    background: rgba(19, 22, 37, 1);
    .each_item {
      width: 100%;
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .bg_181A23 {
    background: #181a23;
  }
  .h_20 {
    height: 20px;
  }
  // 公告部分
  .notice_box {
    height: 46px;
    position: relative;
    .notice_content {
      width: 100%;
      height: 46px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .horn_box {
        margin-right: 10px;
        width: 20px;
        min-width: 20px;
        height: 20px;
      }
      .notice {
        flex-grow: 1;
        // display: flex;
        // flex-direction: row;
        // align-items: center;
        // justify-content: space-between;
        span {
          font-size: 18px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 46px;
          cursor: pointer;
        }
      }
    }
  }

  // .main_box {
  // background: rgba(0, 10, 34, 1);

  // 五个热门币种部分
  .hot_coin_box {
    padding: 10px 0 30px;
    height: 160px;
    display: flex;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .each_coin {
      position: relative;
      padding: 10px 18px 10px 20px;
      // flex: 1;
      background: #0a0a0c;
      border-radius: 10px;
      box-sizing: border-box;
      margin-right: 10px;
      width: 232px;
      min-width: 232px;
      &:last-child {
        margin-right: 0;
      }
      cursor: pointer;
      .left_contet {
        p {
          height: 20px;
          font-size: 14px;
          color: #e0dcdc;
          line-height: 20px;
        }
        .coin_name {
          margin-bottom: 6px;
          font-size: 16px;
        }
        p:nth-child(2) {
          margin-top: 20px;
          height: 36px;
          font-size: 30px;
          font-family: Impact;
          // color: #b0b8db;
          line-height: 36px;
        }
      }
      .right_contet {
        position: absolute;
        top: 18px;
        right: 18px;
        .up_down {
          height: 24px;
          font-size: 20px;
          font-family: Impact;
          line-height: 24px;
          color: rgba(176, 184, 219, 1);
        }
        // 动态控制字体颜色
        .up_green {
          color: rgba(65, 179, 126, 1);
        }
        .down_red {
          color: rgba(206, 68, 68, 1);
        }
      }
    }
  }
  // 行情部分
  .market_box {
    padding: 20px 0;
    .market-title {
      position: relative;
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, 'PingFang SC';
      font-weight: 600;
      color: #ffffff;
      line-height: 33px;
      &::after {
        position: absolute;
        bottom: -8px;
        left: 0;
        right: 0;
        margin: auto;
        display: inline-block;
        content: '';
        width: 34px;
        height: 4px;
        background: #c02e21;
      }
    }
    .main-coin-key-box {
      display: flex;
      margin-bottom: 20px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      line-height: 20px;
      .key-item {
        position: relative;
        margin-right: 26px;
        color: #848e9c;
        cursor: pointer;
        &.active {
          color: #fff;
          &::after {
            position: absolute;
            bottom: -6px;
            left: 0;
            right: 0;
            margin: auto;
            display: inline-block;
            content: '';
            width: 34px;
            height: 4px;
            background: #c02e21;
          }
        }
      }
    }
    .self_content {
      margin-top: 34px;
    }
  }
  // 查看更多详情
  .look_more {
    margin: 25px auto 0;
    padding-bottom: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    p {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  // 介绍
  .introduce_box {
    padding: 65px 0;
    h1 {
      margin-bottom: 100px;
      height: 48px;
      line-height: 48px;
      font-size: 34px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: #ffffff;
      text-align: center;
    }
    .introduce_content {
      padding: 0 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  // 二维码部分
  .qrcode_wrapper {
    padding: 64px 0;
    .qrcode_content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .computed_box {
        width: 618px;
        height: 392px;
      }
      .qrcode_description {
        width: 572px;
        padding: 24px 0;
        p:nth-child(1) {
          font-size: 36px;
          font-family: PingFangSC-Semibold, 'PingFang SC';
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 50px;
          white-space: nowrap;
        }
        .description {
          margin-top: 20px;
          font-size: 26px;
          font-family: PingFangSC-Regular, 'PingFang SC';
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 37px;
        }
        .download {
          height: 237px;
          margin-top: 57px;
          // display: flex;
          // flex-direction: row;
          // align-items: flex-end;

          p {
            // margin-left: 30px;
            font-size: 28px;
            font-family: PingFangSC-Medium, 'PingFang SC';
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
          }
          .qrcode_img {
            margin-top: 24px;
            display: flex;

            &_item {
              & > img {
                width: 139px;
                height: 139px;
                margin-bottom: 13px;
              }

              &:first-child {
                margin-right: 48px;
              }

              div {
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 20px;
                  height: 20px;
                }
                span {
                  font-size: 16px;
                  font-weight: 500;
                  color: #ffffff;
                  margin-left: 6px;
                  line-height: normal;
                }
              }
            }
          }
        }
      }
    }
  }
  // }
}
</style>
